
<template>
    <div 
        v-if="item.dropdownComponent != ''"
        class="header__nav-link" 
        :class="{
            'header__nav-link--active': item.isActiveItem && !(dropdownActive !== null && dropdownActive.key === item.key),
            'header__nav-link--dropdown-active': (dropdownActive !== null && dropdownActive.key === item.key)
        }" 
    >
        {{ item.label }}
    </div>
    <a 
        v-else
        :href="item.introPrimaryAction.Url"
        class="header__nav-link" 
        :class="{
            'header__nav-link--active': item.isActiveItem && !(dropdownActive !== null && dropdownActive.key === item.key),
            'header__nav-link--dropdown-active': (dropdownActive !== null && dropdownActive.key === item.key)
        }" 
    >
        {{ item.label }}
    </a>
</template>

<script>
export default {
    props: ["dropdownActive", "item"],
    data() {
        return {
        }
    },
    mounted() {

    },

}
</script>

